import { Questionnaire } from '@/api/generated-catch-backend/model';
import { useFullScreen } from '@/queries/layout.queries';
import { useQuestionnaireContext } from '../context/QuestionnaireContext';

export function useQuestionnaireLoading(providedQuestionnaire?: Questionnaire) {
  const { state, dispatch } = useQuestionnaireContext();
  useFullScreen(!!providedQuestionnaire);

  return {
    isLoading: state.isLoading,
    setLoading: (loading: boolean) => dispatch({ type: 'SET_LOADING', payload: loading }),
  };
}
